import React, {useState} from 'react'
import {Link as RouterLink} from 'react-router-dom'

import {AppContainer} from '@shared/components/AppContainer'

import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Box,
    Button,
    Divider,
    Grid,
    InputAdornment,
    Link,
    Tab,
    Tabs,
    TextField,
    Theme,
    Typography
} from '@mui/material'
import Breadcrumbs from '@mui/material/Breadcrumbs'

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import SearchIcon from '@mui/icons-material/Search'
import {makeStyles} from '@mui/styles'

const useStyles = makeStyles((theme: Theme) => ({
    textLeft: {
        justifyContent: 'flex-start !important'
    },
    mrAuto: {
        marginRight: 'auto'
    },
    accordion: {
        padding: '16px'
    },
    root: {
        "&.Mui-selected": {
            backgroundColor: `${theme.palette.primary.dark} !important`,
            color: 'white !important',
            '& button': {
                color: 'white !important',
            },
            //https://github.com/mui/material-ui/issues/29842
            /*"&.Mui-focusVisible": { background: `${theme.palette.primary.dark} !important`,
                color: 'white !important',
                '& button': {
                    color: 'white !important',
                }}*/
        }
    }
}))

export const HelpCenter = () => {
    const classes = useStyles();
    const [tabValue, setTabValue] = useState(1);
    const breadcrumbs = [
        <Link key="1" component={RouterLink} to="/tokens" color="inherit" href="/">
            <strong>Home</strong>
        </Link>,
        <Typography key="2" color="inherit">
            <strong>Help Center</strong>
        </Typography>
    ];

    const handleTabValueChange = (event: any, newTabValue: number) => {
        setTabValue(newTabValue)
    };

    const tabsArray = [
        <>
            <Box mb={4}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        className={classes.accordion}
                    >
                        <Typography><strong>About Stakes</strong></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            <p>Welcome to Stakes – your premier destination for managing your Memberships
                                from your favorite restaurants, bars , clubs and more! To get started, simply
                                purchase a Membership through the Stakes app, or where applicable, import
                                your Membership from participating Stakes partners.</p>

                            <p>Then just sync your crypto wallet with your Stakes Account. We currently only
                                support MetaMask, so you’ll need a MetaMask wallet to transact.</p>

                            <p>Once you have synced your crypto wallet you can manage all available perks
                                provided with your Memberships through the Stakes app.</p>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Box>

        </>,
        <>
            <Box mb={4}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        className={classes.accordion}
                    >
                        <Typography><strong>Membership NFTs</strong></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Membership NFTs are ownable memberships that provide real-world perks for
                            owners. Each Membership NFT has its own unique perks and benefits that can be
                            utilized to provide owners with privileges and benefits at the restaurant, bar or club
                            that sold the membership. A Membership NFT provides an ownable loyalty program
                            that can be bought and sold via the blockchain, in any NFT marketplace including
                            OpenSea.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </>,
        <>
            <Box mb={4}>
                <Accordion>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon/>}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        className={classes.accordion}
                    >
                        <Typography><strong>Payments</strong></Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Stakes currently only supports crypto currency transactions - you’ll need a crypto
                            wallet to buy or sell Membership NFTs on Stakes. We are currently only supporting
                            MetaMask, however we will soon support WalletConnect, which will allow you to
                            choose from dozens of wallets.
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </Box>
        </>

    ];

    return <AppContainer>
        <Box my={4}>
            <Breadcrumbs separator="›" aria-label="breadcrumb">
                {breadcrumbs}
            </Breadcrumbs>
        </Box>
        <Grid container spacing={2}>
            <Grid item md={4} xs={12}>
                {/*<Box>
                    <Typography variant='h5'><strong>How can we help?</strong></Typography>
                    <Box my={2}> <Typography>Type your question or search for keywords</Typography></Box>
                    <form autoComplete="off" className="w-100">
                        <TextField
                            id="searchBox"
                            placeholder="Enter title"
                            size="small"
                            className="w-100"
                            variant="outlined"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchIcon/>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </form>
                </Box>
                <Box my={4} sx={{display: {xs: 'none', md: 'initial'}}}>
                    <Divider/>
                </Box>
                */}
                <Box my={4}>
                    <Tabs
                        orientation="vertical"
                        className="hover"
                        style={{cursor: 'pointer'}}
                        value={tabValue}
                        onChange={handleTabValueChange}
                        textColor='primary'
                        indicatorColor='primary'
                        aria-label='User Settings'

                    >
                        <Tab classes={{root: classes.root}} value={1} label='Getting Started'/>
                        <Tab className={classes.root} value={2} label='Memberships'/>
                        <Tab className={classes.root} value={3} label='Payments'/>
                        {/*<Tab className={classes.root} value={4} label='User guide'/>*/}
                    </Tabs>

                </Box>
            </Grid>
            <Grid item md={8} xs={12} sx={{display: {xs: 'none', md: 'initial'}}}>{/*Desktop View*/}
                <Box my={2}>
                    {tabsArray[tabValue - 1]}
                </Box>
            </Grid>

            <Grid item md={8} xs={12} sx={{display: {xs: 'initial', md: 'none'}}}>
                <Box my={4}>
                    <Tabs
                        className="hover"
                        style={{cursor: 'pointer'}}
                        value={tabValue}
                        onChange={handleTabValueChange}
                        textColor='primary'
                        indicatorColor='primary'
                        aria-label='User Settings'
                    >
                        <Tab value={1} label='Getting Started'/>
                        <Tab value={2} label='Memberships'/>
                        <Tab value={3} label='Payments'/>
                        <Tab value={4} label='User guide'/>
                    </Tabs>
                    <Box my={2}>
                        {tabsArray[tabValue - 1]}
                    </Box>
                </Box>
            </Grid>
        </Grid>
    </AppContainer>
}
